import { render, staticRenderFns } from "./ServiceSuper.vue?vue&type=template&id=43f37ea4&scoped=true"
import script from "./ServiceSuper.vue?vue&type=script&lang=js"
export * from "./ServiceSuper.vue?vue&type=script&lang=js"
import style0 from "./ServiceSuper.vue?vue&type=style&index=0&id=43f37ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f37ea4",
  null
  
)

export default component.exports